<template>
  <el-dialog
    :visible.sync="dialogVipVisible"
    width="30%"
    :before-close="handleClose"
    :append-to-body="true"
    :modal-append-to-body="false"
    z-index="99999"
    :show-close="false"
  >
    <span class="close-icon" @click="handleClose"></span>
    <iframe
      :src="h5Url"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      allow="clipboard-read; clipboard-write"
      class="custom-iframe"
    ></iframe>
  </el-dialog>
</template>

<script>
export default {
  name: "ActivityVip",
  props: ["dialogVipVisible", "id", "token", "actUrl"],
  data() {
    return {
      h5Url: "",
      isLoading: true,
    };
  },
  watch: {
    dialogVipVisible(newVal) {
      if (newVal) {
        this.gitH5Url();
        console.log(this.h5Url);
      }
    },
  },
  methods: {
    gitH5Url() {
      // this.h5Url = `http://localhost:6100/activity?id=${this.id}&token=${this.token}`;
      this.h5Url = this.actUrl;
    },
    handleClose() {
      this.$emit("closePayActivity");
    },
  },
};
</script>

<style scoped>
::v-depp .el-dialog__wrapper {
  min-width: 400px;
  max-width: 450px;
}
::v-deep .el-dialog {
  margin-top: 10vh !important;
  max-width: 375px;
  height: 85vh;
}
::v-deep .el-dialog__headerbtn {
  outline: none !important;
  border: none !important;
}
::v-deep .el-dialog__body {
  width: 100%;
  height: calc(85vh * 2);
  padding: 0;
  margin: 0;
}

/* 针对大屏幕 (宽度大于1920px) */
@media screen and (min-width: 1920px) {
  ::v-deep .el-dialog__body {
    height: calc(85vh * 3);
  }
}

/* 针对小屏幕 (宽度小于1200px) */
@media screen and (max-width: 1200px) {
  ::v-deep .el-dialog__body {
    height: calc(85vh * 1.5);
  }
}
::v-deep .el-dialog__header {
  padding: 0;
}
.close-icon {
  position: absolute;
  width: 13px;
  height: 13px;
  top: 15px;
  right: 15px;
  background: url(../../assets/images/invite/clone.png) no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}
.close-icon:hover {
  background: url(../../assets/images/invite/clonehover.png) no-repeat center;
  background-size: 100% 100%;
}
</style>
